<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>Create Service Requisition</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Create Service Requisition</ion-title>
        </ion-toolbar>
      </ion-header>

      <div id="container">
        <Dropdown @change="companyChanged" v-model="company" :options="companies" optionLabel="name" dataKey="value" placeholder="Company" :required="true" :filter="true" filterPlaceholder="Company" />
        <ion-item>
            <ion-label position="floating">Client <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" @IonChange="clientChanged" v-model="postData['client_id']">
                <ion-select-option v-for="(client,i) of clients" :key="i" :value="client.id">{{client.client_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Ship <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" @IonChange="shipChanged" v-model="postData['ship_id']">
                <ion-select-option v-for="(ship,i) of ships" :key="i" :value="ship.id">{{ship.ship_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Problem <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="postData['problem']">
                <ion-select-option value="Signal">Signal</ion-select-option>
                <ion-select-option value="Charge">Charge</ion-select-option>
                <ion-select-option value="Device Broken">Device Broken</ion-select-option>
                <ion-select-option value="Device Burst">Device Burst</ion-select-option>
                <ion-select-option value="Others">Others</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Contact Person</ion-label>
            <ion-input mode="ios" v-model="postData['contact_person']"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Contact Number</ion-label>
            <ion-input mode="ios" type="tel" v-model="postData['contact_number']"></ion-input>
        </ion-item>
        <Dropdown @change="portChanged" v-model="port" :options="ports" optionLabel="name" dataKey="value" placeholder="Service Port" :filter="true" filterPlaceholder="Service Port" />
        <ion-item>
            <ion-label position="floating">Service Date & Time</ion-label>
            <ion-datetime mode="ios" v-model="postData['service_date_time']" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY hh:mm A" min="2015-01-01" max="2030-12-12"></ion-datetime>
        </ion-item>
        <ion-item>
              <ion-label position="floating">Remarks</ion-label>
              <ion-textarea  v-model="postData['remarks']"></ion-textarea>
        </ion-item>

        <!-- Billing decision (phase 4): the warranty is advice; the creator decides free / chargeable and types the amounts. -->
        <div class="billing-box">
          <div class="billing-title">Billing decision</div>
          <div class="warranty" :class="'warranty-' + (warranty ? warranty.state : 'unknown')">
            {{ warrantyText }}
          </div>
          <div v-if="openService" class="open-service">
            Open service #{{ openService.id }} ({{ openService.problem }}): {{ openService.summary }}
          </div>
          <ion-item>
              <ion-label position="floating">Decision</ion-label>
              <ion-select mode="ios" interface="action-sheet" v-model="postData['billing_status']">
                  <ion-select-option value="Undecided">Decide later</ion-select-option>
                  <ion-select-option value="Free">Free (no charge)</ion-select-option>
                  <ion-select-option value="Chargeable">Chargeable</ion-select-option>
              </ion-select>
          </ion-item>
          <template v-if="postData['billing_status'] === 'Chargeable'">
            <ion-item>
                <ion-label position="floating">Service visit (Tk)<span v-if="suggested.visit"> · suggestion {{ suggested.visit }}</span></ion-label>
                <ion-input mode="ios" type="number" inputmode="decimal" v-model="postData['visit_amount']"></ion-input>
            </ion-item>
            <ion-item>
                <ion-label position="floating">Replacement device (Tk)<span v-if="suggested.replacement"> · suggestion {{ suggested.replacement }}</span></ion-label>
                <ion-input mode="ios" type="number" inputmode="decimal" v-model="postData['replacement_amount']" placeholder="Blank if free or not replaced"></ion-input>
            </ion-item>
            <ion-item>
                <ion-label position="floating">Other (Tk)</ion-label>
                <ion-input mode="ios" type="number" inputmode="decimal" v-model="postData['other_amount']"></ion-input>
            </ion-item>
            <ion-item>
                <ion-label position="floating">Other: what for</ion-label>
                <ion-input mode="ios" v-model="postData['other_description']"></ion-input>
            </ion-item>
          </template>
          <ion-item>
              <ion-label position="floating">Billing note (why)</ion-label>
              <ion-input mode="ios" v-model="postData['billing_note']"></ion-input>
          </ion-item>
          <p class="billing-hint">The amounts are what the customer is told. The decision can be changed in the admin panel after the visit until it is invoiced; every change is logged.</p>
        </div>

        <ion-button expand="block" @click="save()" color="primary">Save</ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script >
import { IonButtons, IonButton, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonInput, IonItem, IonLabel,IonSelect,IonSelectOption,IonDatetime,IonTextarea,alertController } from '@ionic/vue';
import Loading from '../Loading';
import Dropdown from './modules/Dropdown.vue';

const emptyPost = () => ({
    'company_id':null,
    'client_id':null,
    'ship_id':null,
    'problem':null,
    'contact_person':'',
    'contact_number':'',
    'port_id':'',
    'service_date_time':'',
    'remarks':'',
    'billing_status':'Undecided',
    'visit_amount':'',
    'replacement_amount':'',
    'other_amount':'',
    'other_description':'',
    'billing_note':'',
});

export default {
  name: 'Create Service Requisition',
  data(){
    return {
    companies:[],
    company:'',
    ports:[],
    port:'',
    clients:[],
    ships:[],
    warranty:null,
    openService:null,
    suggested:{},
    postData:emptyPost()
    }
  },
  computed:{
    warrantyText(){
      if(!this.postData['ship_id']){ return 'Select a ship to see its warranty.'; }
      return this.warranty ? 'Warranty: ' + this.warranty.text : 'Checking warranty...';
    }
  },
  created(){
    this.$http.get('getCompany',).then(response=>{
        const coms=[];
        for(const com of response.data){
            coms.push({
                name:com.company_name,
                value:com.id
            });
        }
      this.companies=coms;
    });
    this.$http.get('getPort',).then(response=>{
      this.ports=[];
      for(const port of response.data ){
        this.ports.push({
          name:port.port_name,
          value:port.id
        });
      }
      // this.ports=response.data;
    });
  },
  methods:{
    clearDateTime(event){
      event.target.value='';
    },
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
    async save(){
        const requireds=[
            'company_id',
            'client_id',
            'ship_id',
            'problem'
        ];
        for(const required of requireds){
            if(this.postData[required]=='' || this.postData[required]==null){
                let name=required;
                name=name.replace('_id','');
                name=name.replace('_',' ');
                this.presentAlert(name);
                return;
            }
        }
        if(this.postData.contact_number!='' && this.postData.contact_number.length!=11){
          this.presentResponseAlert('Alert','Contact Number must be 11 digit');
          return;
        }
        if(this.postData.billing_status==='Chargeable' && !(Number(this.postData.visit_amount)>0 || Number(this.postData.replacement_amount)>0 || Number(this.postData.other_amount)>0)){
          this.presentResponseAlert('Alert','A chargeable service needs at least one amount above 0 (visit, replacement or other).');
          return;
        }
        const data=this.postData;
        data['username'] = window.localStorage.username,
        data['password'] = window.localStorage.password,
      this.$http.post('service_requisition_submissions',data).then(response=>{
        if(response.status==200){
        this.postData=emptyPost();
        this.company=null;
        this.port=null;
        this.warranty=null;
        this.openService=null;
          this.presentResponseAlert('Success','Service Requisiton Created Successfully');

        }
      }).catch(error=>{
        const message = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Could not save the service requisition.';
        this.presentResponseAlert('Error', message);
      });
    },
    async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message+" is required",
          buttons: ['OK'],
        });
      await alert.present();

    },
    async companyChanged(){
        const loading = await Loading.presentLoading('Loading');
        this.postData['company_id']=this.company.value;
        this.postData['client_id']=null;
        this.$http.get('getClient',{params:{id:this.company.value}}).then(response=>{
            this.clients=response.data;
            loading.dismiss();
        });
    },
    async clientChanged(){
        this.postData['ship_id']=null;
        this.warranty=null;
        this.openService=null;
        const loading = await Loading.presentLoading('Loading');
        this.$http.get('getShip',{params:{id:this.postData['client_id']}}).then(response=>{
            this.ships=response.data;
            loading.dismiss();
        });
    },
    // Warranty advice, suggested amounts and any open service of the chosen ship.
    shipChanged(){
        this.warranty=null;
        this.openService=null;
        if(!this.postData['ship_id']){ return; }
        this.$http.get('get_ship_warranty',{params:{
            ship_id:this.postData['ship_id'],
            username:window.localStorage.username,
            password:window.localStorage.password,
        }}).then(response=>{
            this.warranty=response.data.warranty || {state:'none', text:'No warranty on record'};
            this.suggested=response.data.suggested || {};
            this.openService=response.data.service_requisition_id ? {id:response.data.service_requisition_id, problem:response.data.problem, summary:response.data.summary} : null;
        }).catch(()=>{
            this.warranty={state:'unknown', text:'could not be checked'};
        });
    },
    portChanged(){
        this.postData['port_id']=this.port.value;
    },
  },
  components: {
    IonButtons,
    IonButton,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonInput,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonDatetime,
    Dropdown,
    IonTextarea
  }

}
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  /* top: 50%; */
  /* transform: translateY(-50%); */
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
.p-dropdown{
width: 100%;
color:#000;
}
.required{
  color:rgb(233, 0, 0)
}
.billing-box{
  margin: 12px 8px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  text-align: left;
}
.billing-title{
  font-weight: 600;
  margin-bottom: 4px;
}
.warranty{
  font-size: 13px;
  padding: 4px 8px;
  border-radius: 4px;
  background: #f2f2f2;
}
.warranty-active{ background: #e6f7e6; color: #1b7a1b; }
.warranty-expired, .warranty-void{ background: #fdeaea; color: #a81818; }
.warranty-none{ background: #fff6e0; color: #8a5a00; }
.open-service{
  font-size: 12px;
  color: #555;
  margin: 4px 0;
}
.billing-hint{
  font-size: 12px !important;
  margin-top: 6px !important;
}
</style>
